import { AxiosPromise } from 'axios';
import { gfhAPI } from '../httpClient';
import utils from '../../utils';

export interface Reservation {
  reservationId: string;
  roomId: string;
  sourceId: number;
  checkInDate: number;
  checkOutDate: number;
  guestId: string;
  guestName: string;
  guestSurname: string;
  phoneNumber: string;
  nights: number;
  note: string;
  preferredEmail: string;
  email: string;
  reservationCode: string;
  status: number;
  currency: string;
  price: number;
  checkInDateWithTime: number;
  checkOutDateWithTime: number;
  addedDate: number;
  lastUpdateDate: number;
  isDeleted: number;
  isModified: number;
  hostId: string;
  numOfAdults: number;
  numOfKids: number;
  numOfInfants: number;
  homeAwayReferenceNumber: number;
  guestFormShortLink: string;
  porterReservationPrice: number;
  roomAlias: string;
  roomName: string;
}

export interface ReservationsSearchResponse {
  success: boolean;
  errorCode: number;
  errorMessage: string;
  message: string;
  reservationList: Reservation[];
}

const reservations = {
  search({
    page = 0,
    searchText = '',
  }): AxiosPromise<ReservationsSearchResponse> {
    const { authenticatedData } = utils.getLocalStorageByKey(
      'sessionToken',
      'authenticatedData',
      'uuid'
    );
    const userId = authenticatedData?.baseUserInfo?.userId;

    return gfhAPI.post('/reservations/recent/search', {
      page,
      searchText,
      userId,
    });
  },
};

export default reservations;
